import { photographyMap } from "./photography.js";
//import { getStorage, ref, getDownloadURL } from "firebase/storage";
//import { initializeApp } from "firebase/app";
//const firebaseConfig = {
//  apiKey: "AIzaSyB0kufyU91sj2a_eSWV_zAer2FNk3-qzYA",
//  authDomain: "remyamand-6fb76.firebaseapp.com",
//  projectId: "remyamand-6fb76",
//  storageBucket: "remyamand-6fb76.appspot.com",
//  messagingSenderId: "868119576826",
//  appId: "1:868119576826:web:f0e0781f20f348af030943"
//};

//initializeApp(firebaseConfig);
//const storage = getStorage();

export let assetsMap = {
    busy: true, // true by default
    version: 6, // update at each file revision
    ...photographyMap,
    tropicalLager: {
        date: "17-06-2020",
        name: "Tropical Lager",
        file: "/assets/vrac/tropicalLager.png",
        colorTheme: "#f8b18e",
    },
    limboAnimation: {
        date: "17-06-2020",
        name: "Limbo Animation",
        file: "/assets/limbo/limboAnimation.jpg",
        video: "/assets/limbo/limboAnimation.mp4",
        collection: "limbo",
        colorTheme: "#555656",
    },
    ginProject1: {
        date:"13-01-2022",
        name: "Gin bottle",
        file: "/assets/dr_jake_hill/jk1.jpg",
        collection: "ginProject",
        colorTheme: "#fb5513"
    },
    ginProject1B: {
        file: "/assets/dr_jake_hill/jk1B.jpg",
        collection: "ginProject",
        colorTheme: "#fb5513"
    },
    ginProject2: {
        date:"13-01-2022",
        name: "Gin bottle",
        file: "/assets/dr_jake_hill/jk2.jpg",
        tile: "contain",
        collection: "ginProject",
        colorTheme:"#9e4a95",
    },
    ginProject2B: {
        file: "/assets/dr_jake_hill/jk2B.jpg",
        tile: "contain",
        collection: "ginProject",
        colorTheme:"#9e4a95",
    },
    ginProject3: {
        date:"13-01-2022",
        name: "Gin bottle",
        file: "/assets/dr_jake_hill/jk3.jpg",
        tile: "contain",
        collection: "ginProject",
        colorTheme: "#e5cf00",
    },
    ginProject3B: {
        file: "/assets/dr_jake_hill/jk3B.jpg",
        tile: "contain",
        collection: "ginProject",
        colorTheme: "#e5cf00",
    },
    _3d_iso1: {
        date: "15-11-2021",
        name: "3D Isometric building",
        file: "/assets/_3d_iso/Victor_Valentino1.jpeg",
        collection: "_3d_iso",
        sideB: "_3d_iso2",
        colorTheme:"#50477c",
    },
    _3d_iso2: {
        file: "/assets/_3d_iso/Victor_Valentino2.jpeg",
        colorTheme:"#313775",
    },
    mixMedia1: {
        date: "30-11-2021",
        name:"A cat in the bloom",
        file: "/assets/mix_media/mixMedia1.jpeg",
        tile: "contain",
        colorTheme:"#eae0d4",
        collection:"mix_media",
    },
    mixMedia2: {
        date: "30-11-2021",
        name:"A cat in the bloom",
        file: "/assets/mix_media/mixMedia2.jpeg",
        tile: "contain",
        colorTheme:"#d9ba8c",
        collection:"mix_media",
    },
    mixMedia3: {
        date: "30-11-2021",
        name:"A cat in the bloom",
        file: "/assets/mix_media/mixMedia3.jpeg",
        tile: "contain",
        colorTheme:"#ddded8",
        collection:"mix_media",
    },
    patternCoffee: {
        file: "/assets/barista/pattern-coffee.jpg"
    },
    baristaCongo1: {
        date: "10-11-2021",
        name:"Coffee box - Congo",
        file: "/assets/barista/congoBox.jpg",
        sideB: "baristaCongo2",
        colorTheme:"#cda5c0",
        collection: "baristaCoffee"
    },
    baristaCongo2: {
        file: "/assets/barista/congoBar.jpg",
        collection: "baristaCoffee"
    },
    baristaSumatra1: {
        date: "10-11-2021",
        name:"Coffee box - Sumatra",
        file: "/assets/barista/sumatraBox.jpg",
        sideB: "baristaSumatra2",
        colorTheme:"#c2b79b",
        collection: "baristaCoffee"
    },
    baristaSumatra2: {
        file: "/assets/barista/sumatraBar.jpg",
        collection: "baristaCoffee"
    },
    baristaEthiopia: {
        date: "10-11-2021",
        name:"Coffee box - Ethiopia",
        file: "/assets/barista/ethiopiaBox.jpg",
        colorTheme:"#cbb874",
        collection: "baristaCoffee"
    },
    baristaColumbia: {
        date: "10-11-2021",
        name:"Coffee box - Columbia",
        file: "/assets/barista/columbiaBox.jpg",
        colorTheme:"#85b5b5",
        collection: "baristaCoffee"
    },
    sportsLino: {
        date:"15-10-2021",
        name: "Linocut of Sports ",
        file: "/assets/linogravure_sportifs/linogravure_sportifs_ensemble.jpeg",
        colorTheme:"#ebebeb",
        collection: "linocutSports",
        tile: "contain"
    },
    restSticker: {
        date:"15-10-2021",
        name: "Stickers mockup",
        file: "/assets/rest/stickersMockupRest.jpg",
        colorTheme:"#e7d8b7",
        collection: "restProject",
    },
    restMockup: {
        date:"15-10-2021",
        name: "REST project mockup",
        file: "/assets/rest/mockupRest.jpg",
        colorTheme:"#e7d8b7",
        collection: "restProject",
    },
    restSocialMockup: {
        date:"15-10-2021",
        name: "Social post mockup",
        file: "/assets/rest/socialMockupRest.jpeg",
        colorTheme:"#e7d8b7",
        collection: "restProject",
        tile: "contain"
    },
    restMarketingVideo: {
        video: "/assets/rest/marketingMockup.mp4",
        date:"15-10-2021",
        name: "Marketing video mockup",
        file: "/assets/rest/marketingMockup.jpg",
        colorTheme:"#e7d8b7",
        collection: "restProject",
        coAuthored: "Quentin Feltz, Alison Frédérix, Henry Romain, Daria Shmakova"
    },
    travelingVideo: {
        video: "/assets/traveling/Traveling.mp4",
        date:"10-05-2022",
        name: "Traveling",
        file: "/assets/traveling/traveling.jpg",
        colorTheme: "#fbbe28",
        collection: "traveling",
        loop: true
    },
    lalisaAnimation: {
        name: "Lalisa - hello",
        file: "/assets/animations/lalisaAnimation.gif",
    },
    smokingAnimation: {
        name: "don't smoke",
        video: "/assets/animations/smokingAnimation.mp4",
        file: "/assets/animations/smokingAnimation.jpg",
        tile: "contain",
        colorTheme: "#0f0c0c"
    },
    animationIncrustation: {
        video: "/assets/animations/animationIncrustation.mp4",
        file: "/assets/animations/animationIncrustation.jpg",
    },
    printerMagazine1: {
        date: "01-06-2022",
        name: "Magazine layout",
        file: "/assets/printerMagazine/printerMagazine1.jpeg",
        collection: "printerMagazine",
    },
    printerMagazine2: {
        date: "01-06-2022",
        name: "Magazine layout",
        file: "/assets/printerMagazine/printerMagazine2.jpeg",
        collection: "printerMagazine",
    },
    printerMagazine3: {
        date: "01-06-2022",
        name: "Magazine layout",
        file: "/assets/printerMagazine/printerMagazine3.jpeg",
        collection: "printerMagazine",
    },
    printerMagazine4: {
        date: "01-06-2022",
        name: "Magazine layout",
        file: "/assets/printerMagazine/printerMagazine4.jpeg",
        collection: "printerMagazine",
    },
    backAndFront: {
        date: "17-06-2022",
        name: "Oceatika magazine",
        file: "/assets/OCEATIKA/back&front.jpeg",
        collection: "oceatika",
        sideB: "page2and3",
    },
    page2and3: {
        file: "/assets/OCEATIKA/page2&3.jpeg",
        collection: "oceatika"
    },
    page4and5: {
        date: "17-06-2022",
        name: "Oceatika magazine",
        file: "/assets/OCEATIKA/page4&5.jpeg",
        collection: "oceatika",
        sideB: "page6and7"
    },
    page6and7: {
        file: "/assets/OCEATIKA/page6&7.jpeg",
        collection: "oceatika"
    },
    oceatikaAnim: {
        name: "OCEATIKA activities",
        file: "/assets/OCEATIKA/OceatikaAnim.gif",
        collection: "oceatika",
        tile: "contain",
        colorTheme: "#fff"
    },
    oceatikaTShirt: {
        date: "17-06-2022",
        name: "Oceatika T-Shirts",
        file: "/assets/OCEATIKA/oceatikaTShirt.png",
        collection: "oceatika"
    },
    oceatikaBusinessCard: {
        date: "17-06-2022",
        name: "Business card",
        file: "/assets/OCEATIKA/oceatikaBusinessCard.jpeg",
        collection: "oceatika",
        sideB: "oceatikaBusinessCard2"
    },
    oceatikaBusinessCard2: {
        file: "/assets/OCEATIKA/oceatikaBusinessCard2.jpeg",
        collection: "oceatika",
    },
    oceatikaCompliment: {
        date: "17-06-2022",
        name: "Compliment card",
        file: "/assets/OCEATIKA/oceatikaCompliment.png",
        collection: "oceatika"
    },
    oceatikaId: {
        date: "17-06-2022",
        name: "ID badge",
        file: "/assets/OCEATIKA/oceatikaId.png",
        collection: "oceatika"
    },
    oceatikaPaper: {
        date: "17-06-2022",
        name: "Oceatika",
        file: "/assets/OCEATIKA/oceatikaPaper.png",
        collection: "oceatika"
    },
    oceatikaEvent1: {
        date: "17-06-2022",
        name: "Oceatika",
        file: "/assets/OCEATIKA/eventOCEATIKA1.jpeg",
        collection: "oceatika"
    },
    oceatikaEvent2: {
        date: "17-06-2022",
        name: "Oceatika",
        file: "/assets/OCEATIKA/eventOCEATIKA2.jpeg",
        collection: "oceatika"
    },
    mockupSehPosters: {
        date: "15-08-2022",
        name: "Posters mockup",
        file: "/assets/SEH/MockupSehPosters.jpeg",
        collection: "seh"
    },
    cartonRemerciement: {
        name: "seh",
        file: "/assets/SEH/cartonRemerciement.jpeg",
        collection: "seh",
    },
    paper: {
        name: "seh",
        file: "/assets/SEH/paper.jpeg",
        collection: "seh",
    },
    mockupInvitationCard1: {
        date: "15-08-2022",
        name: "Poster mockup",
        file: "/assets/SEH/mockupInvitationCard1.jpeg",
        collection: "seh",
        sideB: "mockupInvitationCard2"
    },
    mockupInvitationCard2: {
        file: "/assets/SEH/mockupInvitationCard2.jpeg",
        collection: "seh",
    },
    sehPosters: {
        date: "15-08-2022",
        name: "Posters mockup",
        file: "/assets/SEH/Poster1&2.jpeg",
        collection: "seh"
    },
    sehPoster1: {
        date: "15-08-2022",
        name: "Poster mockup",
        file: "/assets/SEH/Poster1.jpeg",
        collection: "seh",
        sideB: "sehPoster2"
    },
    sehPoster2: {
        file: "/assets/SEH/Poster2.jpeg",
        collection: "seh",
    },
    tierraWhack: {
        date: "15-03-2022",
        name: "Album cover - Tierra Whack",
        file: "/assets/album_covers/tierraWhack.jpeg",
        collection: "albumCovers",
        sideB: "tierraWhackB",
        animation: "animateFlip",
        tile: "contain"
    },
    tierraWhackB: {
        file: "/assets/album_covers/tierraWhackB.jpeg",
        collection: "albumCovers"
    },
    raisingHell: {
        date: "15-03-2022",
        name: "Album cover - Raising Hell",
        file: "/assets/album_covers/raisingHell.jpeg",
        collection: "albumCovers",
        sideB: "raisingHellB",
        animation: "animateFlip",
        tile: "contain"
    },
    raisingHellB: {
        file: "/assets/album_covers/raisingHellB.jpeg",
        collection: "albumCovers"
    },
    operationDoomsday: {
        date: "15-03-2022",
        name: "Album cover - Operation Doomsday",
        file: "/assets/album_covers/operationDoomsday.jpeg",
        collection: "albumCovers",
        sideB: "operationDoomsdayB",
        animation: "animateFlip",
        tile: "contain"
    },
    operationDoomsdayB: {
        file: "/assets/album_covers/operationDoomsdayB.jpeg",
        collection: "albumCovers"
    },
    coverAlbum1: {
        date: "15-03-2022",
        name: "Album cover",
        file: "/assets/album_covers/coverAlbum1.jpeg",
        collection: "albumCovers"
    },
    coverAlbum2: {
        date: "15-03-2022",
        name: "Album cover",
        file: "/assets/album_covers/coverAlbum2.jpeg",
        collection: "albumCovers"
    },
    coverAlbum3: {
        date: "15-03-2022",
        name: "Album cover",
        file: "/assets/album_covers/coverAlbum3.jpeg",
        collection: "albumCovers"
    },
    mockupTypoUp: {
        date: "15-02-2022",
        name: "turbulences",
        file: "/assets/turbulences/mockupTypoUp.jpeg",
        collection: "turbulences",
    },
    mockupTypoLow: {
        date: "15-02-2022",
        name: "turbulences",
        file: "/assets/turbulences/mockupTypoLow.jpeg",
        collection: "turbulences",
    },
    mockupBrand1: {
        date: "15-02-2022",
        name: "turbulences",
        file: "/assets/turbulences/mockupBrand1.jpeg",
        collection: "turbulences",
    },
    mockupBrand2: {
        date: "15-02-2022",
        name: "turbulences",
        file: "/assets/turbulences/mockupBrand2.jpeg",
        collection: "turbulences",
    },
    turbulencesPoster: {
        date: "15-02-2022",
        name: "turbulences",
        file: "/assets/turbulences/turbulencesPoster.jpg",
        collection: "turbulences",
    },
    mockupEvent1: {
        date: "15-02-2022",
        name: "turbulences",
        file: "/assets/turbulences/mockupEvent1.jpeg",
        collection: "turbulences",
    },
    mockupEvent2: {
        date: "15-02-2022",
        name: "turbulences",
        file: "/assets/turbulences/mockupEvent2.jpeg",
        collection: "turbulences",
    },
    mockupEvent3: {
        date: "15-02-2022",
        name: "turbulences",
        file: "/assets/turbulences/mockupEvent3.jpeg",
        collection: "turbulences",
    },
    mockupEvent4: {
        date: "15-02-2022",
        name: "turbulences",
        file: "/assets/turbulences/mockupEvent4.jpeg",
        collection: "turbulences",
    },
    mockupPosterEvent1: {
        date: "15-02-2022",
        name: "turbulences",
        file: "/assets/turbulences/mockupPosterEvent1.jpeg",
        collection: "turbulences",
    },
    mockupPosterEvent2: {
        date: "15-02-2022",
        name: "turbulences",
        file: "/assets/turbulences/mockupPosterEvent2.jpeg",
        collection: "turbulences",
    },
    outOfBox1: {
        date: "15-05-2022",
        name: "turbulences",
        file: "/assets/turbulencesOob/outOfBox1.png",
        collection: "turbulencesOob",
    },
    outOfBox2: {
        date: "15-05-2022",
        name: "turbulences",
        file: "/assets/turbulencesOob/outOfBox2.png",
        collection: "turbulencesOob",
    },
    outOfBoxPoster: {
        date: "15-05-2022",
        name: "Poster",
        file: "/assets/turbulencesOob/poster.gif",
        collection: "turbulencesOob",
    },
    outOfBoxIcon: {
        file: "/assets/turbulencesOob/outOfBoxIcon.gif",
        collection: "turbulencesOob",
    },
    noriPastaFront: {
        date: "15-05-2022",
        name: "Packaging",
        file: "/assets/theDock/noriPastaFront.jpg",
        collection: "theDock",
        sideB: "noriPastaBack"
    },
    noriPastaBack: {
        file: "/assets/theDock/noriPastaBack.jpg",
        collection: "theDock",
    },
    dulsePastaFront: {
        date: "15-05-2022",
        name: "Packaging",
        file: "/assets/theDock/dulsePastaFront.jpg",
        collection: "theDock",
        sideB: "dulsePastaBack"
    },
    dulsePastaBack: {
        file: "/assets/theDock/dulsePastaBack.jpg",
        collection: "theDock",
    },
    vervaineTeafront: {
        date: "15-05-2022",
        name: "Packaging",
        file: "/assets/theDock/vervaineTeafront.jpg",
        collection: "theDock",
        sideB: "vervaineTeaback"
    },
    vervaineTeaback: {
        file: "/assets/theDock/vervaineTeaback.jpg",
        collection: "theDock",
    },
    canelleTeafront: {
        file: "/assets/theDock/canelleTeaFront.jpg",
        collection: "theDock"
    },
    canelleTeaback: {
        date: "15-05-2022",
        name: "Packaging",
        file: "/assets/theDock/canelleTeaback.jpg",
        collection: "theDock",
        sideB: "canelleTeafront",
        animation: "animateZoom"
    },
    miserecord10years: {
        date: "15-04-2022",
        name: "10 years",
        file: "/assets/miserecordPart2/miserecord10years.jpg",
        collection: "miserecordPart2",
    },
    miserecordTrifold: {
        date: "15-04-2022",
        name: "Trifold",
        file: "/assets/miserecordPart2/miserecordTrifold.jpg",
        collection: "miserecordPart2",
        sideB: "miserecordTrifold2"
    },
    miserecordTrifold2: {
        file: "/assets/miserecordPart2/miserecordTrifold2.jpg",
        collection: "miserecordPart2",
    },
    seasPiracyInvit1: {
        date: "15-06-2022",
        name: "Invitation",
        file: "/assets/seasPiracy/invitation1.jpeg",
        collection: "seasPiracy"
    },
    seasPiracyInvit2: {
        date: "15-06-2022",
        name: "Invitation",
        file: "/assets/seasPiracy/invitation2.jpeg",
        collection: "seasPiracy"
    },
    seasPiracyInvit3: {
        file: "/assets/seasPiracy/invitation3.jpeg",
        collection: "seasPiracy"
    },
    seasPiracyInvit4: {
        file: "/assets/seasPiracy/invitation4.jpeg",
        collection: "seasPiracy"
    },
    seasPiracyInvit5: {
        date: "15-06-2022",
        name: "Invitation",
        file: "/assets/seasPiracy/invitation5.jpeg",
        collection: "seasPiracy"
    },
    seasPiracyPoster1: {
        date: "15-06-2022",
        name: "Invitation",
        file: "/assets/seasPiracy/poster1.jpeg",
        collection: "seasPiracy"
    },
    seasPiracyPoster2: {
        date: "15-06-2022",
        name: "Invitation",
        file: "/assets/seasPiracy/poster2.jpeg",
        collection: "seasPiracy"
    },
    seasPiracyPoster3: {
        date: "15-06-2022",
        name: "Invitation",
        file: "/assets/seasPiracy/poster3.jpeg",
        collection: "seasPiracy"
    },
    seasPiracyPoster4: {
        date: "15-06-2022",
        name: "Invitation",
        file: "/assets/seasPiracy/poster4.jpeg",
        collection: "seasPiracy"
    },
    hafgufa1: {
        date: "15-06-2022",
        name: "Poster",
        file: "/assets/hafgufa/hafgufa1.jpeg",
        collection: "hafgufa"
    },
    hafgufa2: {
        date: "15-06-2022",
        name: "Poster",
        file: "/assets/hafgufa/hafgufa2.jpeg",
        collection: "hafgufa"
    },
    experimentations: {
        file: "/assets/album_covers/experimentations.jpg"
    },
    miserecordLogo: {
        file: "/assets/album_covers/miserecord.png"
    },
    theDockLogo: {
        file: "/assets/theDock/theDockLogo.gif"
    },
    initialAlbums: {
        file: "/assets/album_covers/initialAlbums.jpg"
    },
    exp1: {
        file: "/assets/album_covers/exp1.jpg"
    },
    exp2: {
        file: "/assets/album_covers/exp2.jpg"
    },
    tileAnimation: {
        file: "/assets/website/tileAnimation.gif"
    },
    layoutExample: {
        file: "/assets/OCEATIKA/layoutExample.jpeg"
    },
    layoutExampleMini: {
        file: "/assets/OCEATIKA/layoutExampleMini.jpeg"
    },
    graphicalChart: {
        file: "/assets/OCEATIKA/charteGraphique.jpeg"
    },
    graphicDesign: {
        file: "/assets/turbulences/graphicDesign.jpeg"
    },
    graphicDesignMini: {
        file: "/assets/turbulences/graphicDesignMini.jpeg"
    }
}

const checkImage = (src, asset) => {
    const file = asset.file;
    asset.thumbnail = "./assets/loading.gif";
    const img = new Image();
    img.onload = () => asset.thumbnail = file.replace("/assets", "/thumbnails");
    img.onerror = () => {
        asset.name && console.log("Missing thumbnail for:" + src);
        asset.thumbnail = file;
    };
    img.src = src;
}

Object.entries(assetsMap).forEach(async ([item, content]) => {
    if (typeof assetsMap[item] !== "object") return;
    const name = content.file;
    assetsMap[item].file = "./assets/loading.gif";
    if (assetsMap[item].file) {
        assetsMap[item].file = "." + name;
        const thumb = name.replace("/assets", "./thumbnails");
        checkImage(thumb, assetsMap[item]);
    }
    if (assetsMap[item].video) {
        assetsMap[item].video = "." + assetsMap[item].video;
    }
});

// The following part is currently disabled until a larger
// assets structure is required

/*const savedAssets = JSON.parse(localStorage.getItem("fetchedAssets"));
if (!savedAssets || assetsMap.version !== savedAssets.version) {
    console.info("Assets fetched from server");
    Object.entries(assetsMap).forEach(async ([item, content]) => {
        if (typeof assetsMap[item] !== "object") return;
        const name = content.file;
        assetsMap[item].file = "./assets/loading.gif";
        if (assetsMap[item].video) {
            const name = content.video;
            assetsMap[item].video = "loading";
            const reference = ref(storage, name);
            assetsMap[item].video = await getDownloadURL(reference);
        }
        const reference = ref(storage, name);
        assetsMap[item].file = await getDownloadURL(reference);
    });
} else {
    console.info("Assets reloaded from cache");
    delete savedAssets.timestamp;
    Object.entries(photographyMap).forEach(([item, content]) => {
        content.file = savedAssets[item].file;
    });
    assetsMap = savedAssets;
}*/

export const imageInitializer = (setter, source, id) => {
    const entries = Object.entries(assetsMap);
    if (assetsMap.busy && !entries.find(e => e[1].file === "./assets/loading.gif" || e[1].thumbnail === "./assets/loading.gif")) {
        delete assetsMap.busy;
        localStorage.setItem("fetchedAssets", JSON.stringify({
            ...assetsMap,
            timestamp: Date.now()
        }));
    }
    if (typeof source === "object" && (source.file === "./assets/loading.gif")) {
        return setTimeout(() => {
            setter({ ...assetsMap[id] });
        }, 10);
    }
    if (typeof source === "string") {
        return setTimeout(() => {
            setter(entries.filter(i => i[1][source]));
        }, 40);
    }
    if (!source) {
        return setTimeout(() => {
            setter({...assetsMap});
        }, 40);
    }
}